import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsListPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import WorksListPage from "../pages/works/page";
import WorkDetailPage from "../pages/works/detail/page";
import ProfilePage from "../pages/profile/page";
import SearchPage from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <NewsListPage />,
  },
  {
    path: "/news/detail/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/works",
    element: <WorksListPage />,
  },
  {
    path: "/works/detail/:id",
    element: <WorkDetailPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;